import {customAxiosBE} from "../config";
import axios from "axios";
import {parsePaginationParams} from "../../utils/other";

export async function getAllActionsAPI(payload) {
    return customAxiosBE.get(`/salesActions?page=${payload.page}&size=${payload.rowsPerPage}`)
}

export async function getActionsAPI(id) {
    return customAxiosBE.get(`/salesActions/${id}`)
}

export async function insertActionsAPI(data){
    return customAxiosBE.post(`/salesActions`, data)
}
export async function updateActionsAPI(data){
    return customAxiosBE.put(`/salesActions`, data)
}

export async function deleteActionsAPI(id){
    return customAxiosBE.delete(`/salesActions/${id}`,)
}

export async function deactivateActionAPI(id){
    return customAxiosBE.post(`/salesActions/changeStatus`,id);
}
export const searchActionsAPI = async (data, cancelToken) => {
    let response
    const {name} = data
    const params = parsePaginationParams(data)
    await customAxiosBE
        .post(`/salesActions/search?${params}`, {
            name: name
        }, {
            cancelToken
        })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}

export async function getCurrentActions(){
    return customAxiosBE.get(`/salesActions/current`)
}
